export default "__VITE_ASSET__BaGY7fQB__"